module.exports = __webpack_public_path__ + "img/1.282ca880.png";